import React  from 'react';
import Popup from '../popups/popup';
import ListingReminder from "../listing/listingReminder";

class PopupListingReminder extends Popup {
    constructor(props) {
        super(props);

        this.hide = this.hide.bind(this);
    }
    static initPopup(props = {}) {
        props.preventLocationBack = true;
        props.stopAnimation ? props.stopAnimation() : null;
        Popup.initPopup.call(this, props);
        this.props = props;
    }

    _onPopupClose() {
        if (this.props.stopAnimation) {
            this.props.stopAnimation();
        }
    }

    hide() {
        window.dispatchEvent(new Event('popstate'));
    }

    content() {
        return <div className='remind-later-popup'>
            <ListingReminder step={this.props.step} version={this.props.version} />
        </div>;
    }
}

PopupListingReminder.defaultProps = {
    popupClassName: 'popup-listing-reminder',
    single: true,
    modal: true,
    onPopupClose: function() {
        this._onPopupClose();
    }
};

export default PopupListingReminder
